module.exports = __webpack_public_path__ + "img/wide.c2ebf66a.jpg";